import { setDefaultValues, setToTopDimIds } from '../dimensionUtils'
export function createDefaultPivotConfig(dimensions) {
  let chart = 'bar-chart'
  let dimOptions = dimensions.dimensionOptions
  let metas = dimensions.dimensionMetas

  let pivotConfig
  pivotConfig = {
    dimensions: Object.keys(dimOptions).map(key => {
      let type = metas[key].type
      let role = type === 'time' ? 'filters' : /*type === 'location' ? 'columns' :*/ 'filters'
      if (type === 'time') {
        role = 'filters'
      }
      return {
        id: key,
        role: role,
      }
    }),
  }

  Object.keys(metas).forEach(key => {
    if (metas[key].typeOptions.length > 0) {
      pivotConfig.dimensions.push({
        id: key + '_type',
        role: 'types',
      })
    }
  })

  //CALCULAMOS ARRAYS
  // let rowDims = pivotConfig.dimensions.filter(d => d.role === 'rows')
  // let columnDims = pivotConfig.dimensions.filter(d => d.role === 'columns')
  // let filterDims = pivotConfig.dimensions.filter(d => d.role === 'filters')
  // let noTimeFilters = pivotConfig.dimensions.filter(
  //   d => d.role === 'filters' && metas[d.id].type !== 'time'
  // )

  // RELLENAMOS UNO A ROWS SI FALATA
  // if (rowDims.length < 1) {
  //   if (noTimeFilters.length > 0) noTimeFilters[0].role = 'rows'
  //   else filterDims[0].role = 'rows'
  // }

  // //ACTUALIZAMOS ARRAYS
  // filterDims = pivotConfig.dimensions.filter(d => d.role === 'filters')
  // noTimeFilters = pivotConfig.dimensions.filter(
  //   d => d.role === 'filters' && metas[d.id].type !== 'time'
  // )

  // // RELLENAMOS UNO A ROWS SI FALATA
  // if (columnDims.length < 1) {
  //   if (noTimeFilters.length > 0) noTimeFilters[0].role = 'columns'
  //   else filterDims[0].role = 'columns'
  // }

  // setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)

  // let rowsDim = pivotConfig.dimensions.find(d => d.role === 'rows')
  // if (metas[rowsDim.id].type === 'location' && rowsDim.values.length === 1) {
  //   if (filterDims.length > 0) {
  //     filterDims = filterDims.slice(0, 2)
  //     filterDims.forEach(d => (d.role = 'rows'))
  //     rowsDim.role = 'filters'
  //   } else {
  //     let colsDim = pivotConfig.dimensions.find(d => d.role === 'columns')
  //     rowsDim.role = 'columns'
  //     colsDim.role = 'rows'
  //   }
  //   setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)
  // }

  //RELLENAMOS ROWS Y COLS

  // let rowsDims = pivotConfig.dimensions.filter(d => d.role === 'rows')
  // let filetrsDims = pivotConfig.dimensions.filter(d => d.role === 'filters')
  // let colsDims = pivotConfig.dimensions.filter(d => d.role === 'columns')

  let extraDims = Object.values(dimensions.dimensionMetas).filter(
    d => d.type !== 'time' && d.type !== 'location'
  )

  let filtersExtraDims = pivotConfig.dimensions.filter(
    d => d.role === 'filters' && extraDims.find(ed => ed.id === d.id)
  )

  // let locDim = pivotConfig.dimensions.filter(
  //   d => d.role === 'filters' && metas[d.id].type === 'location'
  // )

  // let timeDim = pivotConfig.dimensions.filter(
  //   d => d.role === 'filters' && metas[d.id].type === 'time'
  // )

  let rowsDims = pivotConfig.dimensions.filter(d => d.role === 'rows')
  let colsDims = pivotConfig.dimensions.filter(d => d.role === 'columns')

  let toRows
  let toCols
  // let locDimUsed = false

  if (rowsDims.length === 0 && filtersExtraDims.length > 0) {
    toRows = filtersExtraDims.slice(0, 1)
    toRows.forEach(d => (d.role = 'rows'))
    setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)
  }
  // else if (rowsDims.length === 0 && filtersExtraDims.length === 0 && locDim.length !== 0) {
  //   toRows = locDim.slice(0, 1)
  //   locDimUsed = true
  //   toRows.forEach(d => (d.role = 'rows'))
  //   setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)
  // }
  filtersExtraDims = pivotConfig.dimensions.filter(
    d => d.role === 'filters' && extraDims.find(ed => ed.id === d.id)
  )
  if (colsDims.length === 0 && filtersExtraDims.length > 0) {
    toCols = filtersExtraDims.slice(0, 1)
    toCols.forEach(d => (d.role = 'columns'))
    setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)
  }
  // else if (
  //   colsDims.length === 0 &&
  //   filtersExtraDims.length === 0 &&
  //   !locDimUsed &&
  //   locDim.length !== 0
  // ) {
  //   toCols = locDim.slice(0, 1)
  //   toCols.forEach(d => (d.role = 'columns'))
  //   setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)
  // } else if (
  //   colsDims.length === 0 &&
  //   filtersExtraDims.length === 0 &&
  //   locDimUsed &&
  //   timeDim.length !== 0
  // ) {
  //   toCols = timeDim.slice(0, 1)
  //   toCols.forEach(d => (d.role = 'columns'))
  //   setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)
  // }

  // if (colsDims.length === 1 && colsDims[0].values.length === 1) {
  //   colsDims[0].role = 'filters'
  //   toCols = filetrsDims.slice(0, 1) // [filetrsDims[0]]
  //   toCols.forEach(d => (d.role = 'columns'))
  //   setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)
  // }

  setToTopDimIds(pivotConfig, metas)

  setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)

  return pivotConfig
}

export function getAvailability(dimensions) {
  // let metas = Object.values(dimensions.dimensionMetas)
  // let hasExtraDims = metas.filter(d => d.type !== 'time' && d.type !== 'location').length > 0
  return { enabled: dimensions.dimensions.length > 1, enableable: dimensions.dimensions.length > 1 }
  //return { enabled: true, enableable: true }
}

export default {
  getAvailability,
  createDefaultPivotConfig,
  maxChartDims: 2,
  maxRowDims: 1,
  sdvComponent: 'HeatMap',
}
